import { supabase } from "@/lib/supabase/supabaseClient";

export const getUserData = async () => {
  const { data: userSession, error: userSessionError } =
    await supabase.auth.getSession();
  if (userSessionError) {
    if (userSessionError instanceof Error) {
      console.error(userSessionError.message);
      throw userSessionError;
    }
    throw new Error("Unknown error getting user session");
  }
  const userId = userSession.session?.user.id;
  if (!userId) {
    throw new Error("No user session found");
  }
  return await supabase
    .from("user")
    .select("*")
    .eq("id", userId)
    .maybeSingle()
    .throwOnError()
    .then((res) => res.data);
};
